/**
 * Pure helpers for Kusto cluster / ADX-proxy URLs. Process-agnostic:
 * imported by both the renderer (connection form) and the main process
 * (connection manager). The full URL is stored in Connection.server (D9).
 */

export function normalizeKustoClusterUrl(input: string): string {
  const trimmed = input.trim();
  if (!trimmed) return '';
  const withScheme = /^https?:\/\//i.test(trimmed)
    ? trimmed.replace(/^http:\/\//i, 'https://')
    : `https://${trimmed}`;
  return withScheme.replace(/\/+$/, '');
}

const KUSTO_PROXY_HOSTS: ReadonlySet<string> = new Set(['ade.applicationinsights.io', 'ade.loganalytics.io']);

/**
 * An App Insights / Log Analytics query proxy, recognised on the PARSED URL (Option C C3 review r3, C3-17): an explicit
 * `:443` or any other spelling the URL parser reads as that host is the proxy, as the client dials it.
 */
export function isKustoProxyUrl(url: string): boolean {
  try {
    return KUSTO_PROXY_HOSTS.has(new URL(normalizeKustoClusterUrl(url)).hostname.toLowerCase());
  } catch {
    return false;
  }
}

/**
 * A Kusto server without connection-string properties: the text before the first `;` (Option C C3 review r2, C3-11).
 * Kusto is the one engine whose connection string can START with its address (`https://<cluster>/<db>;Fed=True;AppKey=…`),
 * so property text — a secret included — must never be kept as the server that is shown and saved.
 */
export function withoutKustoProperties(server: string): string {
  return (server.split(';')[0] ?? '').trim();
}
